export function teachingTechniqueSave(values) {
  return `mutation {
    teachingTechniqueSave(                              
      teachingTechnique: {id: ${values.id ? values.id : 0}
                    , name: "${
                      values.name
                    }"                                            
                    , description: "${
                      values.description ? values.description : ''
                    }"
                    , active: ${values.active}
                    , filterByStatus: false                                        
                    , updaterId: 0
                }),
    {id}
}`;
}

export function teachingTechniqueListByFilter(filter) {
  const query = `{teachingTechniqueListByFilter(filter:  ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}) {id, name, description, active}}`;
  return query;
}

export function teachingTechniqueRemove(value) {
  return `mutation {teachingTechniqueRemove(id: ${value.id})}`;
}

export function techingTechniqueListAll() {
  return '{teachingTechniqueListAll{id, name, active}}';
}
